export const extractLinkDataFromUrl = (location) => {
    const currentOrigin = window.location.origin;
    const pathname = location ? location.pathname : '';
    const fullHash = location ? location.hash : undefined;
    const invitationSecretKey = fullHash ? fullHash.slice(1) : '';
    return {
        currentOrigin,
        fullHash,
        invitationSecretKey,
        pathname,
    };
};
export const constructGuestLink = ({ currentOrigin, encodedEncryptedFileName, encodedFileData, linkFormatVersion, }) => {
    return `${currentOrigin}?linkPath=/g/${linkFormatVersion}/${encodedFileData}/${encodedEncryptedFileName}`;
};
